import React, { useCallback } from 'react';
import { ListItem, Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { isWeb } from 'utils/deviceUtils';
import { ListItemWrapper, Row } from './styles';
import { useAttachmentRow } from './useAttachmentRow';

const AttachmentRowTitle: React.FC<{ title: string }> = ({ title }) => (
  <Meta color={theme.colors.gray300}>{title}</Meta>
);

const AttachmentRowRightContent: React.FC<{
  displayName: string;
  pressable: boolean;
}> = ({ displayName, pressable }) => (
  <Row>
    <Meta numberOfLines={1} ellipsizeMode="tail">
      {displayName}
    </Meta>
    {pressable && <Icon name="Chevron_Right" />}
  </Row>
);

type AttachmentCardRowProps = {
  noBorder?: boolean;
  pressable?: boolean;
};

const AttachmentCardRow: React.FC<AttachmentCardRowProps> = ({
  noBorder = false,
  pressable = true,
}) => {
  const { title, displayName, fullName, handlePress } = useAttachmentRow({
    pressable,
  });

  const renderTitle = useCallback(
    () => <AttachmentRowTitle title={title} />,
    [title]
  );
  const renderRightContent = useCallback(
    () => (
      <AttachmentRowRightContent
        displayName={displayName}
        pressable={pressable}
      />
    ),
    [displayName, pressable]
  );

  // Web has no working attachment flow: no picker modal and no preview route.
  if (isWeb) return null;

  return (
    <ListItemWrapper noBorder={noBorder}>
      <ListItem
        accessible
        accessibilityLabel={`${title}: ${fullName}`}
        testID="selected-attachment"
        onPress={pressable ? handlePress : undefined}
        withBackground={theme.colors.lightBg.green}
        item={null}
        indexValue={0}
        titleComponent={renderTitle}
        rightContentComponent={renderRightContent}
      />
    </ListItemWrapper>
  );
};

export default AttachmentCardRow;
